class ImageLoader {

    constructor(AppWeb = null) {
        this.AppWeb = AppWeb;
    }

    landingLogoLoader(element) {
        if (element.files && element.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                $('#logoImage').attr('src', e.target.result);
            }
            $('#logoViewer').css('display', 'block');
            reader.readAsDataURL(element.files[0]);
        }
    }

    bindAll(context) {

    }
}

module.exports = ImageLoader;


// WEBPACK FOOTER //
// ./devel/js/images/imageLoader.js